/*============================================================================
  Ajax the add-to-cart experience by revealing it in a right side drawer
  This file includes two aspects:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}
/*============================================================================
  API Helper Functions
==============================================================================*/
function convertToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};
/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  //alert('There are now ' + cart.item_count + ' items in the cart.');
};
ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + convertToString(note),
    dataType: 'json',
    success: function(cart) {
      if((typeof callback) === 'function'){
        callback(cart);
      }else{
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};
/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  console.log('-----------addItemFromForm----------------');
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};
//Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};
//POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
//POST to cart/clear.js returns the cart in JSON
ShopifyAPI.clearAll = function(callback) {
  var params = {
    type: 'POST',
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function(cart) {
      if((typeof callback) === 'function'){
        callback(cart);
      }else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCartPopup = (function(module, $) {
  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector,$cartCountHeadSelector,$cartCostHeadSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;
  var buildItemHtml;
  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    //Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#Cart-popup-drawer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '#cart-products-count span',
      cartCostSelector   : '#cart-subtotal',
      cartCountHeadSelector  : '.CartCount',
      cartCostHeadSelector   : '.CartCost',
      moneyFormat        : '$'
    };
    //Override defaults with arguments
    $.extend(settings, options);
    //Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $cartCountHeadSelector = $(settings.cartCountHeadSelector);
    $cartCostHeadSelector  = $(settings.cartCostHeadSelector);

    $body = $('body');
    //Track cart activity status
    isUpdating = false;
    //formOverride();
    //Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };
  loadCart = function () {
    $body.addClass('drawer--is-loading').addClass('ai-open-cart');
    $cartContainer.addClass('active');
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  updateCountPrice = function (cart) {
    if ($cartCountHeadSelector) {
      $cartCountHeadSelector.html(cart.item_count);
    }
    if ($cartCostHeadSelector) {
      $cartCostHeadSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).parent().parent().removeClass('hidden-count');
      if (cart.item_count === 0) {
        $cartCountSelector.parent().parent().addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };
  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      $addToCart.removeClass('is-added').addClass('is-adding');
      //Remove any previous quantity errors
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };
  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.product-add');
        $addButtoncontainer.before('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };
  cartUpdateCallback = function (cart) {
    //Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };
  buildCart = function(cart) {
    //$cartContainer.empty();
    if (cart.item_count === 0) {
      $('#ai-sticky-cart').html('<p>' + "Your cart is currently empty." + '</p>');
      return;
    }
    var items = [],
      item = {},
      data = {};
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
      } else {
        prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }
      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;
          cartItem.line_level_discount_allocations[ discount ].formattedAmount = Shopify.formatMoney(amount, settings.moneyFormat );
        }
      }
      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;

          cart.cart_level_discount_applications[cartDiscount].formattedAmount = Shopify.formatMoney(cartAmount,settings.moneyFormat);
        }
      }
      // Create item's data object and add to 'items' array
      item = {
        availablity:cartItem.available,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: (cartItem.variant_title != null? cartItem.variant_title : ' '),
        variant_id: cartItem.variant_id,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(
          cartItem.price,
          settings.moneyFormat
        ),
        line_price: Shopify.formatMoney(
          cartItem.line_price,
          settings.moneyFormat
        ),
        original_price: Shopify.formatMoney(
          cartItem.original_price,
          settings.moneyFormat
        ),
        original_line_price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        final_price: Shopify.formatMoney(
          cartItem.final_price,
          settings.moneyFormat
        ),
        final_line_price: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor
      };
      itemsHtml = itemsHtml + buildItemHtml(item);
      items.push(item);
    });
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0
    };
    var itemsHtml = '';
    $.each(items,function(index,cartItem) {
          itemsHtml = itemsHtml + buildItemHtml(cartItem);
    });
    $('#ai-sticky-cart').empty().append(itemsHtml);
    cartCallback(cart);
  };
  buildItemHtml = function(item){
    var oc_price = 0;
    if (item.original_price > item.final_price){
        oc_price = item.original_price;
    }else if (item.compare_at_price > item.final_price){
        oc_price = item.compare_at_price;
    }
    var outofstockClass = '';
    var itemAvailablity = true;
    if(static_cart_variant.length > 0){
      for(var ii in static_cart_variant){
        if(static_cart_variant[ii].id == item.variant_id){
          if(static_cart_variant[ii].available == false){
            outofstockClass = ' outofstock';
            itemAvailablity = false;
          }
        }
      }
    }    
    if(itemAvailablity){
        var cartItemrighthtml = '<div class="ai-cart-content-price">'+
                              '<span class="ai-price-total ai-variant-' + item.variant_id + '-price-total ai-desktop">' + item.line_price + '</span>'+
                              '<span class="ai-original-price-total ai-variant-' + item.variant_id + '-original-price-total ai-desktop">'+
                              '<span class="ai-quantity-original-price">x' + item.itemQty + '</span>' + item.original_price + '</span>'+
                          '</div>';
    }else{
        var cartItemrighthtml = '<div class="soldout">Sold Out</div>';
    }
    var itemHtml = '<div class="ai-item-cart-content ai-product-' + item.variant_id + outofstockClass + '" data-line="'+item.line+'">'+
                      '<div class="ai-item-content-variants">'+
                          '<div class="ai-item-cart-image">'+
                              '<a href="' + item.url + '" title="' + item.name + '">'+
                                  '<div class="box-ratio" style="padding-bottom: 100.0%;">'+
                                      '<img class="lazyload lazyload-fade" id="product_img_' + item.variant_id + '" src="' + item.img + '" data-src="' + item.img + '" data-widths="[90,360]" alt="' + item.name + '"  data-sizes="auto">'+
                                  '</div>'+
                              '</a>'+
                          '</div>'+
                          '<div class="ai-item-cart-description">'+
                              '<a href="' + item.url + '" class="ai-product-title">'+ item.name +'</a>'+
                              '<span class="ai-variant-title">' + item.variation + '</span>'+
                              '<div class="ai-content-quantity-price">'+
                                  '<span class="ai-price-total ai-variant-' + item.variant_id + '-price-total ai-mobile">'+
                                       '<div class="item-pricing">'+
                                          '<p><b>' + item.price + '</b></p>'+
                                          '<p>'+
                                              '<span class="cart-item-price money" data-key="' + item.key + '" style="margin-right: 5px;">'+ item.final_price +  '</span>'+
                                              '<span class="money">'+
                                                  '<del>'+ oc_price + '</del>'+
                                              '</span>'+
                                           '</p>'+
                                        '</div>'+
                                   '</span>'+
                                  '<div class="ai-item-cart-content-quantity">'+
                                      '<div class="ai-item-cart-qty ai-item-' + item.variant_id + '">'+
                                          '<div class="ai-cart-plus-minus" data-quantity="' + item.itemQty + '" data-id="' + item.variant_id + '" data-line="' + item.line + '">'+
                                              '<div class="dec qty-button" data-line="' + item.line + '">-</div>'+
                                              '<input type="text" class="qty-num" value="' + item.itemQty + '" data-id="' + item.variant_id + '" data-line="' + item.line + '">'+
                                              '<div class="inc qty-button" data-line="' + item.line + '">+</div>'+
                                          '</div>'+
                                      '</div>'+
                                  '</div>'+
                                  '<div class="ai-item-close">'+
                                      '<a href="javascript:void(0);" class="ai-remove-item" data-id="' + item.variant_id + '" data-line="' + item.line + '">Clear</a>'+
                                  '</div>'+
                              '</div>'+
                          '</div>'+
                          cartItemrighthtml+
                      '</div>'+
                  '</div>';
      return itemHtml;
  };
  cartCallback = function(cart){
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
    if(window.Shopify && Shopify.StorefrontExpressButtons){
      Shopify.StorefrontExpressButtons.initialize();
    }
  };
  adjustCart = function(){
      // Delegate all events because elements reload with the cart
      // Add or remove from the quantity
      $body.on('click','.qty-button',function() {
        var $el = $(this),
            line = $el.data('line'),
            $qtySelector = $el.siblings('.qty-num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        // Add or subtract from the current quantity
        if($el.hasClass('inc')){
          qty += 1;
        }else{
          qty -= 1;
          if (qty <= 0) qty = 0;
        }
        // If it has a data-line, update the cart.
        // Otherwise, just update the input's number
        if(line){
          updateQuantity(line, qty);
        }else{
          $qtySelector.val(qty);
        }
      });
      // Update quantity based on input on change
      $body.on('change','#Cart-popup-drawer .qty-num',function() {
        var $el = $(this),
            line = $el.data('line'),
            qty = parseInt($el.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        // If it has a data-line, update the cart
        if (line){
          updateQuantity(line, qty);
        }
      });
      // Prevent cart from being submitted while quantities are changing
      $body.on('submit', 'form.ajaxcart', function(evt) {
        if (isUpdating) {
          evt.preventDefault();
        }
      });
      // Highlight the text when focused
      $body.on('focus','.qty-button',function(){
        var $el = $(this);
        setTimeout(function(){
          $el.select();
        }, 50);
      });
      function updateQuantity(line,qty){
        isUpdating = true;
        // Add activity classes when changing cart quantities
        var $row = $('.ai-cart-plus-minus[data-line="' + line + '"]').addClass('is-loading');
        if (qty === 0){
          $row.parent().addClass('is-removed');
        }
        // Slight delay to make sure removed animation is done
        setTimeout(function(){
          ShopifyAPI.changeItem(line,qty,adjustCartCallback);
        }, 250);
      }
      //Save note anytime it's changed
      $body.on('change','textarea[name="note"]',function(){
        var newNote = $(this).val();
        //Update the cart note in case they don't click update/checkout
        ShopifyAPI.updateCartNote(newNote,function(cart){});
      });
      $body.on('click','.ai-close',function(){
         $body.removeClass('drawer--is-loading').removeClass('ai-open-cart');
         $cartContainer.removeClass('active');
      });
      $body.on('click','.ai-remove-item',function(){
          var $el = $(this),
             line = $el.data('line');
          ShopifyAPI.changeItem(line, 0, adjustCartCallback);
      });
      $body.on('click','.ai-clear-all-button',function(){
 		  ShopifyAPI.clearAll(adjustCartCallback);
          $('.related-product-item').removeClass('addedIntoCart');
          $('.product-index').removeClass('addedtocart');
      });
      $body.on('click',function(event){
        event.stopPropagation();
        if($(event.target).hasClass('ai-open-cart')){
          $body.removeClass('drawer--is-loading').removeClass('ai-open-cart');
          $cartContainer.removeClass('active');
        }
      });
  };
  adjustCartCallback = function(cart){
    isUpdating = false;
    // Update quantity and price
    updateCountPrice(cart);
    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };
  validateQty = function(qty){
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){
      // We have a valid number!
    }else{
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart
  };
  return module;
}(ajaxCartPopup || {}, jQuery));